/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleView extends models.RoleBase {
    getFixupPrototypeFunction() { return RoleView.fixupPrototype; }

    static newInstance(model: Partial<RoleView>): RoleView {
        let obj = Object.assign(new RoleView(), model);
        RoleView.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleView>): RoleView {
        if (!model) return null;
        return RoleView.newInstance(<RoleView> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleView) {
        if (!obj) return;

        models.RoleView.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleView): boolean {
        if (models.RoleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RoleView.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.number_of_users === undefined) {
            this.number_of_users = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
    }

    /**
     * ID of the Role. Auto generated and unique in the CoreStack system
     */
    id: string;

    /**
     * ID of the tenant the role belongs to
     */
    tenant_id: string;

    /**
     * Category of the role - default or custom
     */
    category: models.RoleCategory;

    /**
     * Status of the role
     */
    status: models.RoleStatus;

    /**
     * Date and time when the role was created
     */
    created_at: Date;

    /**
     * Number of users associated with the role
     */
    number_of_users: number;

}
